
export default {
  name: "FormInput",

  props: {
    errorText: {
      type: String,
      required: false,
      default: 'Error'
    },

    value: {
      type: String,
      required: false,
    },

    type: {
      type: String,
      required: false,
      default: 'text'
    },

    placeholder: {
      type: String,
      required: false,
      default: ''
    },

    mb: {
      type: Number,
      required: false,
      default: 0
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    width: {
      type: Number,
      required: false,

    },

    left: {
      type: Number,
      required: false,
      default: 50
    },

    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'off'
    },
    addElement: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    dataCy: {
      type: String,
      required: false,
      default: ''
    },    
  },


  mixins: [],
  components: {},
  data() {
    return {
      showPassword: false,
    }
  },
  computed: {
    eyeIcon() {
      return this.showPassword ? "eye" : "eye-slash";
    },
    inputType() {
      return this.showPassword ? "text" : this.type;
    },     
  },
  mounted() {
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
}
